<template>
  <v-container class="mt-4">

     <span v-if="successBestellung">
     <h3 class="text-green">Wir werden Ihnen den neuen WaizmannTabellen in Kürze kostenlos zusenden.</h3>
   </span>
   <span v-else>
     <h3 class="text-orange">Wir bearbeiten gerade Ihre Anforderung</h3>
   </span>


   </v-container> 
 </template>
 
 <script setup>
 import { inject, onMounted,ref,reactive } from 'vue'
 import { storeToRefs } from 'pinia'
 import { useRoute } from 'vue-router'
 
 const baseCalls = inject('baseCalls')
 const loaderStore = inject('loaderStore');
 const userStore = inject('userStore');
 const successStore = inject('successStore');
 const errorStore = inject('errorStore');
 const { userData } = storeToRefs(userStore)
 const successBestellung = ref(false);


 
 const bestellung = reactive({
     bestell_status: 0,
     bestell_comment: "",
     bestell_produkt_text: "",
     bestell_kategorie: 0,
     action: 'neueBestellung',
 
   });
 const route = useRoute();
 async function startLogin() {
   const data = { action: 'startlogin',token: route.params.token }
   //console.log(data);
  
   loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");
   try {
     const response = await baseCalls.userPost(data);
     if (response.data.user ) {
       startNeueBestellung('WaizmannTabelle Gesamtausgabe');
       console.log('Benutzerdaten geladen:', response.data);
       userStore.setUser(response.data.user )
 
       loaderStore.setLoader(false);
       
     }  else {
       errorStore.setError( true, 'Fehler beim Laden der Benutzerdaten');
     }
   } catch (err) {
    
     errorStore.setError(true, 'Fehler beim Laden der Benutzerdaten');
     console.error('API-Fehler:', err);
   } finally {
 
     loaderStore.setLoader(false);
   }
 }
 async function startNeueBestellung(product)
 {
   bestellung.bestell_produkt_text = product;
   bestellung.bestell_aktion_id = 371;
   loaderStore.setLoader(true)
   const response = await baseCalls.bestellungPost(bestellung)
   if (response.data.success) {
     if (product == 'WaizmannTabelle Gesamtausgabe') {
       successBestellung.value = true;
       successStore.setSuccess(true,'Ihre Bestellung wurde erfolgreich gespeichert','Ihre Bestellung wird in Kürze bearbeitet.')
       setTimeout(() => {
         successStore.setSuccess(false,'','')
       }, 1000);
     } 
  
     loaderStore.setLoader(false)
     
     bestellung.bestell_produkt_text = '';
     bestellung.bestell_comment = '';
    
   } else {
    
     errorStore.setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
   }
 }
 onMounted(() => {
   if (!userData.value && route.params.token != null) {
     startLogin();
   }
 });
 
   //import { reactive, ref } from "vue";
 </script>
 